<div class="main-background main-body notranslate">

  <!-- ============ LAYOUT: Top Header + Content (stejný pro admin i user) ============ -->
  <app-rep-header></app-rep-header>
  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Loading overlay -->
  <div class="loader-bg" *ngIf="shared.loading">
    <div class="loader-classic">
      <div class="spinner-border text-primary" role="status">
      </div>
    </div>
  </div>

  <simple-notifications></simple-notifications>

</div>
